import { useState } from 'react';
import { useGetEventsQuery } from '@/services/api/event/eventApi';

/**
 * Custom hook for managing event data
 * Provides pagination and search functionality for events
 */
export const useEventData = () => {
  // ==========================================
  // Pagination State
  // ==========================================
  const [pagination, setPagination] = useState({
    page: 1,
    per_page: 10,
  });

  // ==========================================
  // Search State
  // ==========================================
  const [search, setSearch] = useState("");

  // ==========================================
  // Pagination Handlers
  // ==========================================
  const handlePageChange = (page) => {
    setPagination(prev => ({ ...prev, page }));
  };

  const handlePageSizeChange = (per_page) => {
    setPagination({ page: 1, per_page });
  };

  // ==========================================
  // Search Handler
  // ==========================================
  const handleSearch = (searchTerm) => {
    const trimmedSearch = searchTerm.trim();
    setSearch(trimmedSearch);
    setPagination(prev => ({ ...prev, page: 1 }));
  };

  const {
    data: response = { data: [], pagination: {}, statistics: {} },
    isLoading,
    isFetching,
    error,
    refetch
  } = useGetEventsQuery({
    page: pagination.page,
    per_page: pagination.per_page,
    search: search,
  });

  // console.log(response, "Fetched Events Data");

  // Extract data from the transformed response
  const eventsData = response.data || [];
  const paginationInfo = response.pagination || {};
  const statistics = response.statistics || {};

  return {
    // Data
    eventsData,
    
    // Pagination info
    paginationInfo: {
      current_page: paginationInfo.current_page || 1,
      last_page: paginationInfo.last_page || 1,
      per_page: paginationInfo.per_page || 10,
      total: paginationInfo.total || 0,
    },
    
    // Pagination handlers
    handlePageChange,
    handlePageSizeChange,
    
    // Search state and handler
    search,
    handleSearch,
    
    // Statistics
    statistics,
    totalEvents: paginationInfo.total || 0,
    activeEvents: statistics.active || 0,
    inactiveEvents: statistics.inactive || 0,
    
    // Loading states
    isLoading,
    isFetching,
    
    // Error states
    error,
    isError: !!error,
    
    // Actions
    refetch
  };
};
